const network=()=>{
    return(
        <>
            <div className="container-fluid pt-5" 
                style={{
                    background:'black',
                }}>
                <h2 className="text-center" style={{
                    fontWeight:'700',
                    color:'white',

                }}>OUR ONLINE PLATFROMS</h2>
                <div className="slider-wrapper pb-5">
                    <div className="slider-text text-uppercase">
                        <span className="slide-item">AMAZON</span>
                        <span className="slide-item">BLINKIT</span>
                        <span className="slide-item">FLIPKART</span>
                        <span className="slide-item">ZEPTO</span>
                        {/* <span className="slide-item">glutine free</span>   */}

                        <span className="slide-item">AMAZON</span>
                        <span className="slide-item">BLINKIT</span>
                        <span className="slide-item">FLIPKART</span>
                        <span className="slide-item">ZEPTO</span>         
                    </div>

                    <div className="slider-text text-uppercase">
                        <span className="slide-item">AMAZON</span>
                        <span className="slide-item">BLINKIT</span>
                        <span className="slide-item">FLIPKART</span>
                        <span className="slide-item">ZEPTO</span>
                        {/* <span className="slide-item">glutine free</span>   */}

                        <span className="slide-item">AMAZON</span>
                        <span className="slide-item">BLINKIT</span>
                        <span className="slide-item">FLIPKART</span>
                        <span className="slide-item">ZEPTO</span>         
                    </div>
                </div>
            </div>
        </>
    )
}
export default network